export default __webpack_public_path__ + "static/media/background.13ef7628.svg";